/** @format */

import {ChangeEvent, useEffect, useState} from 'react';

import {Trans} from 'react-i18next';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

import {useSaveStratLowConvSettingsMutation} from '../../graphql/__generated__';
import {
  Container,
  Description,
  DescriptionWrapper,
  FieldLabel,
  FieldLabelWrapper,
  FieldWrapper,
  StyledTextField,
} from './styles';

interface StratLowConvSettingsProps {
  periodDays: number;
  minConversions: number;
  onSuccess?: () => void;
}

export const StratLowConvSettings = ({
  periodDays: initialPeriodDays,
  minConversions: initialMinConversions,
  onSuccess,
}: StratLowConvSettingsProps) => {
  const [periodDays, setPeriodDays] = useState(initialPeriodDays);
  const [minConversions, setMinConversions] = useState(initialMinConversions);

  const [saveStratLowConvSettings, {loading}] = useSaveStratLowConvSettingsMutation();

  useEffect(() => {
    setPeriodDays(initialPeriodDays);
    setMinConversions(initialMinConversions);
  }, [initialPeriodDays, initialMinConversions]);

  const handlePeriodChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPeriodDays(Number(event.target.value));
  };

  const handleMinConversionsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setMinConversions(Number(event.target.value));
  };

  const handleSave = async () => {
    const settings = {
      periodDays,
      minConversions,
    };

    await saveStratLowConvSettings({variables: {settings}});
    onSuccess?.();
  };

  return (
    <Container>
      <DescriptionWrapper>
        <Description>
          <Trans>Вы можете настроить более точное срабатывание для данного сенсора.</Trans>
        </Description>
      </DescriptionWrapper>
      <FieldLabelWrapper>
        <FieldLabel>
          <Trans>Период анализа, дни</Trans>
        </FieldLabel>
      </FieldLabelWrapper>
      <FieldWrapper>
        <StyledTextField
          type='number'
          value={periodDays}
          onChange={handlePeriodChange}
          inputProps={{
            min: 0,
            'data-testid': 'strat-low-conv-period-input',
          }}
        />
      </FieldWrapper>
      <FieldLabelWrapper>
        <FieldLabel>
          <Trans>Срабатывать, если конверсий меньше чем</Trans>
        </FieldLabel>
      </FieldLabelWrapper>
      <FieldWrapper>
        <StyledTextField
          type='number'
          value={minConversions}
          onChange={handleMinConversionsChange}
          inputProps={{
            min: 0,
            'data-testid': 'strat-low-conv-min-conversions-input',
          }}
        />
      </FieldWrapper>
      <PrimaryMediumButton
        disabled={loading}
        onClick={handleSave}
        data-testid='save-strat-low-conv-settings'
      >
        <Trans>Сохранить</Trans>
      </PrimaryMediumButton>
    </Container>
  );
};
